"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var link_icon_svg_1 = __importDefault(require("@assets/components/user/user-link-table/link-icon.svg"));
var file_icon_svg_1 = __importDefault(require("@assets/components/user/user-link-table/file-icon.svg"));
var click_count_icon_svg_1 = __importDefault(require("@assets/components/user/user-link-table/click-count-icon.svg"));
var TableTag_1 = __importDefault(require("./TableTag"));
var actions_1 = __importDefault(require("../../../../actions"));
var appMargins_1 = __importDefault(require("../../../../../app/components/AppMargins/appMargins"));
var reducers_1 = require("../../../Drawer/ControlPanel/util/reducers");
var Drawer_1 = require("../../../Drawer");
var format_1 = require("../../../../../app/util/format");
var CopyButton_1 = __importDefault(require("../../../../widgets/CopyButton"));
var constants_1 = require("../../../../../../shared/constants");
var useStyles = (0, styles_1.makeStyles)(function (theme) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    return (0, styles_1.createStyles)({
        bar: {
            backgroundColor: theme.palette.grey[500],
        },
        root: (_a = {
                '&:first-child': (_b = {
                        borderTop: 'non'
                    },
                    _b[theme.breakpoints.up('md')] = {
                        borderTop: '1px solid #d8d8d860',
                    },
                    _b),
                borderBottom: '1px solid #d8d8d8'
            },
            _a[theme.breakpoints.up('md')] = {
                borderBottom: 'none',
            },
            _a),
        leftCell: (_c = {},
            _c[theme.breakpoints.up('md')] = {
                textAlign: 'end',
                paddingTop: '0px',
                paddingRight: theme.spacing(1.5),
                paddingLeft: function (props) { return props.appMargins; },
            },
            _c[theme.breakpoints.down('sm')] = {
                display: 'none',
            },
            _c),
        leftCellWithTags: (_d = {},
            _d[theme.breakpoints.up('md')] = {
                textAlign: 'end',
                paddingTop: '0px',
                paddingRight: theme.spacing(1.5),
                paddingBottom: '61px',
                paddingLeft: function (props) { return props.appMargins; },
            },
            _d[theme.breakpoints.down('sm')] = {
                display: 'none',
            },
            _d),
        urlCell: (_e = {
                paddingTop: theme.spacing(3)
            },
            _e[theme.breakpoints.up('md')] = {
                width: '61%',
            },
            _e[theme.breakpoints.down('sm')] = {
                display: 'inline-flex',
                width: '100%',
                padding: theme.spacing(2, 2, 0, 3),
                paddingLeft: function (props) { return props.appMargins; },
            },
            _e),
        shortUrlGrid: (_f = {},
            _f[theme.breakpoints.down('sm')] = {
                width: '100%',
            },
            _f),
        longUrlGrid: {
            padding: theme.spacing(1, 0, 0.5, 0),
        },
        stateCell: (_g = {},
            _g[theme.breakpoints.up('md')] = {
                minWidth: '100px',
            },
            _g[theme.breakpoints.down('sm')] = {
                display: 'inline-flex',
                padding: theme.spacing(1, 2, 2, 3),
                width: '30%',
                minWidth: '110px',
                paddingLeft: function (props) { return props.appMargins; },
            },
            _g),
        createdAtCell: (_h = {},
            _h[theme.breakpoints.up('md')] = {
                minWidth: '125px',
            },
            _h[theme.breakpoints.down('sm')] = {
                display: 'inline-flex',
                padding: theme.spacing(1, 1, 2, 1),
                width: '25%',
                minWidth: '100px',
            },
            _h),
        clicksCell: (_j = {
                paddingRight: function (props) { return props.appMargins; }
            },
            _j[theme.breakpoints.up('md')] = {
                minWidth: '210px',
            },
            _j[theme.breakpoints.down('sm')] = {
                display: 'inline-flex',
                padding: theme.spacing(1, 0, 2, 2),
                width: '40%',
                minWidth: '100px',
            },
            _j),
        clicksCellContent: {
            width: 118,
        },
        clicksCellTooltipContent: {
            display: 'inline-block',
            float: 'right',
        },
        rightCell: (_k = {},
            _k[theme.breakpoints.up('md')] = {
                textAlign: 'right',
                paddingRight: function (props) { return props.appMargins; },
            },
            _k),
        icon: (_l = {
                marginTop: theme.spacing(-0.5)
            },
            _l[theme.breakpoints.down('sm')] = {
                display: 'none',
            },
            _l),
        stateActive: {
            color: '#6d9067',
            textTransform: 'capitalize',
        },
        stateInactive: {
            color: '#c85151',
            textTransform: 'capitalize',
        },
        shortUrl: (_m = {},
            _m[theme.breakpoints.up('md')] = {
                maxWidth: '400px',
            },
            _m[theme.breakpoints.down('sm')] = {
                width: 'calc(100% - 32px)',
            },
            _m.whiteSpace = 'nowrap',
            _m.overflow = 'hidden',
            _m.textOverflow = 'ellipsis',
            _m),
        longUrl: {
            color: '#767676',
        },
        createdAt: {
            color: '#767676',
        },
        clicksIcon: {
            verticalAlign: 'middle',
        },
        clicksText: {
            color: '#767676',
            paddingRight: '4px',
        },
        hoverRow: (_o = {},
            _o[theme.breakpoints.down('sm')] = {
                height: 'auto',
                borderBottom: 'none',
                borderRight: 'none',
                borderLeft: 'none',
            },
            _o['&:hover'] = {
                backgroundColor: theme.palette.background.default,
                cursor: 'pointer',
            },
            _o),
        lastCreatedRow: {
            backgroundColor: theme.palette.background.default,
        },
    });
});
function EnhancedTableBody() {
    var urls = (0, react_redux_1.useSelector)(function (state) { return state.user.urls; });
    var tableConfig = (0, react_redux_1.useSelector)(function (state) { return state.user.tableConfig; });
    var lastCreatedLink = (0, react_redux_1.useSelector)(function (state) { return state.user.lastCreatedLink; });
    var appMargins = (0, appMargins_1.default)();
    var classes = useStyles({ appMargins: appMargins });
    var dispatch = (0, react_redux_1.useDispatch)();
    var drawerDispatch = (0, Drawer_1.useDrawerDispatch)();
    var openControlPanel = function (shortlink) {
        return drawerDispatch({ type: reducers_1.DrawerActions.openControlPanel, payload: shortlink });
    };
    var setSearchByTag = function (tag) {
        var newSearchInput = tableConfig.isTag && tableConfig.searchInput
            ? "".concat(tableConfig.searchInput).concat(constants_1.TAG_SEPARATOR).concat(tag) // append tag to existing tags in search input
            : tag;
        var newConfig = {
            isTag: true,
            searchInput: newSearchInput,
        };
        dispatch(actions_1.default.setUrlTableConfig(newConfig));
    };
    if (urls.length > 0) {
        // If user has existing links, show the user's list of stored links.
        return (react_1.default.createElement(core_1.TableBody, { classes: { root: classes.root } }, urls.map(function (row) { return (react_1.default.createElement(core_1.TableRow, { key: row.shortUrl, className: "".concat(classes.hoverRow, " ").concat(lastCreatedLink === row.shortUrl ? classes.lastCreatedRow : ''), onClick: function () { return openControlPanel(row.shortUrl); } },
            react_1.default.createElement(core_1.TableCell, { className: row.tags.length > 0
                    ? classes.leftCellWithTags
                    : classes.leftCell },
                react_1.default.createElement("img", { className: classes.icon, src: row.isFile ? file_icon_svg_1.default : link_icon_svg_1.default, alt: row.isFile ? 'File' : 'Link' })),
            react_1.default.createElement(core_1.TableCell, { align: "left", className: classes.urlCell },
                react_1.default.createElement(core_1.Grid, { container: true, direction: "column" },
                    react_1.default.createElement(core_1.Grid, { item: true, className: classes.shortUrlGrid },
                        react_1.default.createElement(core_1.Tooltip, { title: row.shortUrl, placement: "top-start", arrow: true },
                            react_1.default.createElement(core_1.Typography, { variant: "h6", className: classes.shortUrl },
                                "/",
                                row.shortUrl))),
                    react_1.default.createElement(core_1.Hidden, { smDown: true },
                        react_1.default.createElement(core_1.Grid, { item: true, className: classes.longUrlGrid },
                            react_1.default.createElement(core_1.Typography, { variant: "caption", className: classes.longUrl }, row.longUrl))),
                    row.tags.length > 0 && (react_1.default.createElement(core_1.Hidden, { smDown: true },
                        react_1.default.createElement(core_1.Grid, { item: true, className: classes.longUrlGrid }, row.tags.map(function (tag) { return (react_1.default.createElement(TableTag_1.default, { key: tag, tag: tag, onClick: function () { return setSearchByTag(tag); } })); })))))),
            react_1.default.createElement(core_1.Hidden, { smDown: true },
                react_1.default.createElement(core_1.TableCell, { className: classes.stateCell },
                    react_1.default.createElement(CopyButton_1.default, { shortUrl: row.shortUrl, buttonText: "Copy", iconSize: 13, variant: "caption", stopPropagation: true }))),
            react_1.default.createElement(core_1.TableCell, { className: classes.stateCell },
                react_1.default.createElement(core_1.Typography, { variant: "caption", className: row.state === 'ACTIVE'
                        ? classes.stateActive
                        : classes.stateInactive },
                    react_1.default.createElement("b", { style: { fontWeight: 900 } }, '• '),
                    row.state.toLowerCase())),
            react_1.default.createElement(core_1.TableCell, { className: classes.createdAtCell },
                react_1.default.createElement(core_1.Typography, { variant: "caption", className: classes.createdAt }, row.createdAt)),
            react_1.default.createElement(core_1.TableCell, { className: classes.clicksCell },
                react_1.default.createElement("div", { className: classes.clicksCellContent },
                    react_1.default.createElement(core_1.Tooltip, { title: row.clicks, placement: "top", arrow: true },
                        react_1.default.createElement("div", { className: classes.clicksCellTooltipContent },
                            react_1.default.createElement("img", { className: classes.clicksIcon, src: click_count_icon_svg_1.default, alt: "Clicks" }),
                            react_1.default.createElement(core_1.Typography, { variant: "caption", className: classes.clicksText }, (0, format_1.numberUnitFormatter)(row.clicks)))))))); })));
    }
    // To return if user does not have any existing links.
    return (react_1.default.createElement(core_1.TableBody, null,
        react_1.default.createElement(core_1.TableRow, null,
            react_1.default.createElement(core_1.TableCell, { className: classes.leftCell }, "No links found"),
            react_1.default.createElement(core_1.TableCell, null),
            react_1.default.createElement(core_1.TableCell, null),
            react_1.default.createElement(core_1.TableCell, null),
            react_1.default.createElement(core_1.TableCell, null),
            react_1.default.createElement(core_1.TableCell, null),
            react_1.default.createElement(core_1.TableCell, { className: classes.rightCell }))));
}
exports.default = EnhancedTableBody;
